import { biosecurity } from './biosecurity';
import { medias } from '../Global/medias';

class BiosecurityAssessorSlides {
  constructor(app, report, evaluation, group, user) {
    this.app = app;
    this.report = report;
    this.evaluation = evaluation;
    this.group = group;
    this.user = user;
  }

  add(tableOfContentsCalculatorPosition) {
    let assessor = this.group.getAssessorByType('6');

    if (assessor === false || assessor.assessor.data === undefined) {
      throw (
        this.group.getName() +
        this.app.$t(' - ') +
        this.app.$t('Biosecurity assessor is not ready.')
      );
    }

    this.report.tableOfContentsHelper('Biosecurity', tableOfContentsCalculatorPosition, this.group);

    biosecurity(this.app, this.report, this.evaluation, this.group, assessor);
    medias(this.app, this.report, this.group, '6', this.user);
  }
}

export default BiosecurityAssessorSlides;
